const variant = JSON.parse(localStorage.getItem("themeVariant"))
    ? JSON.parse(localStorage.getItem("themeVariant"))
    : "light";

if (variant == "dark") {
    document.body.classList.add("dark");
} else {
    document.body.classList.remove("dark");
}
const theme = {
    defaultTheme: variant,
    themes: {
        light: {
            colors: {
                background: "#ebeef1",
                surface: "#ffffff",
                "surface-dim": "#e0e3e9",
                "surface-bright": "#f0f1f4",
                "surface-container-lowest": "#f3f4f6",
                "surface-container-low": "#edeff2",
                "surface-container": "#ebeef1",
                "surface-container-high": "#e8ebef",
                "surface-container-highest": "#e5e8ed",
                "on-surface": "#0d1626",
                "inverse-surface": "#1a2736",
                "inverse-on-surface": "#ebeef1",
                outline: "#55647a",
                "outline-variant": "#d0d9e4",
                primary: "#036daa",
                "on-primary": "#d1ecfd",
                "primary-container": "#a9dffd",
                "on-primary-container": "#065c8d",
                "inverse-primary": "#72cdfb",
                secondary: "#0092ab",
                "on-secondary": "#befdff",
                "secondary-container": "#92fbff",
                "on-secondary-container": "#09768b",
                tertiary: "#4d56bd",
                "on-tertiary": "#dbe6f9",
                "tertiary-container": "#c5d5f5",
                "on-tertiary-container": "#424a9f",
                error: "#c01e1e",
                "on-error": "#fed8d9",
                "error-container": "#febfbf",
                "on-error-container": "#a21b1b",
                "primary-fixed": "#a9dffd",
                "primary-fixed-dim": "#72cdfb",
                "on-primary-fixed": "#082e49",
                "on-primary-fixed-variant": "#065c8d",
                "secondary-fixed": "#92fbff",
                "secondary-fixed-dim": "#57f5ff",
                "on-secondary-fixed": "#023b4a",
                "on-secondary-fixed-variant": "#09768b",
                "tertiary-fixed": "#c5d5f5",
                "tertiary-fixed-dim": "#a9bfef",
                "on-tertiary-fixed": "#212445",
                "on-tertiary-fixed-variant": "#424a9f",
                "surface-light": "#e8ebef",
            },
            dark: false,
            variables: {
                "overlay-background": "#0d1427",
            },
        },
        dark: {
            colors: {
                background: "#101b2b",
                surface: "#020713",
                "surface-dim": "#020713",
                "surface-bright": "#222f3e",
                "surface-container-lowest": "#000209",
                "surface-container-low": "#0d1626",
                "surface-container": "#101b2b",
                "surface-container-high": "#162131",
                "surface-container-highest": "#1d2a39",
                "on-surface": "#e5e8ed",
                "inverse-surface": "#e5e8ed",
                "inverse-on-surface": "#1a2736",
                outline: "#77869d",
                "outline-variant": "#2d3a4d",
                primary: "#72cdfb",
                "on-primary": "#0b4e77",
                "primary-container": "#065c8d",
                "on-primary-container": "#a9dffd",
                "inverse-primary": "#036daa",
                secondary: "#57f5ff",
                "on-secondary": "#0d6173",
                "secondary-container": "#09768b",
                "on-secondary-container": "#92fbff",
                tertiary: "#a9bfef",
                "on-tertiary": "#3b4382",
                "tertiary-container": "#424a9f",
                "on-tertiary-container": "#c5d5f5",
                error: "#fc9b9b",
                "on-error": "#891c1c",
                "error-container": "#a21b1b",
                "on-error-container": "#febfbf",
                "primary-fixed": "#a9dffd",
                "primary-fixed-dim": "#72cdfb",
                "on-primary-fixed": "#082e49",
                "on-primary-fixed-variant": "#065c8d",
                "secondary-fixed": "#92fbff",
                "secondary-fixed-dim": "#57f5ff",
                "on-secondary-fixed": "#023b4a",
                "on-secondary-fixed-variant": "#09768b",
                "tertiary-fixed": "#c5d5f5",
                "tertiary-fixed-dim": "#a9bfef",
                "on-tertiary-fixed": "#212445",
                "on-tertiary-fixed-variant": "#424a9f",
                "surface-light": "#222f3e",
            },
            dark: true,
            variables: {
                "overlay-background": "#0d1427",
            },
        },
    },
};

export default theme;
